// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardOperationsController = function ($scope, $rootScope, $location, $routeParams, $http, $interval, Logs, Job, PrometheusAction, BackbeatAction, Webhook, Migration, VatIdValidationResult, WorkerProcess) {
    var interval = null;
    $scope.autoRefresh = true;

    $scope.logs = [];
    $scope.jobs = [];
    $scope.actions = [];
    $scope.backBeatActions = [];
    $scope.hooks = [];
    $scope.migrations = [];
    $scope.vatIdResult = [];
    $scope.workerProcesses = [];

    $scope.toggleAutoRefresh = function () {
        $scope.autoRefresh = !$scope.autoRefresh;
        if (interval)
            $interval.cancel(interval);
        if ($scope.autoRefresh) {
            load();
            interval = $interval(function () {
                load();
            }, 60000);
        }
    }

    $scope.notSleeping = function (action) {
        return action.State != "Sleeping";
    };

    $scope.requeue = function (id) {
        $http.post('/api/v1/jobs/' + id, {}).success(function () { $scope.jobs = Job.query({ status: 'Failed' }); });
    };

    $scope.retire = function (id) {
        if (confirm("Are you sure you want to retire the job?"))
            $http.post('/api/v1/jobs/' + id + "/retire", {}).success(function () { $scope.jobs = Job.query({ status: 'Failed' }); });
    };

    $scope.dismissLog = function (data) {
        $http.post('/api/v1/logs/dismiss/' + data.Id, {}).success(function () { $scope.logs = Logs.query({ severity: 'Error', take: 10 }); });
    };

    $scope.dismissWebhook = function (data) {
        $http.post('/api/v1/webhooks/' + data.Id, {}).success(function () { $scope.hooks = Webhook.query({ failedFilter: true }); });
    };

    var minDate = new Date(new Date().getTime() - 432000000).toISOString(); //-5 days

    function loadLogs() {
        $rootScope.loadData('logs', function (promise) {
            return Logs.query({ severity: 'Error', take: 10, after: minDate },
                function (value) {
                    $scope.logs = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function loadJobs() {
        $rootScope.loadData('jobs', function (promise) {
            return Job.query({ status: 'Failed' },
                function (value) {
                    $scope.jobs = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function loadActions() {
        $rootScope.loadData('actions', function (promise) {
            return PrometheusAction.query({ filterDisabled: true },
                function (value) {
                    $scope.actions = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function loadBackBeatActions() {
        $scope.filter = {status: 'NotSleeping', actionName: '', entity: ''};

        $rootScope.loadData('backBeatActions', function (promise) {
            return BackbeatAction.query(
                $scope.filter,
                function (value) {
                    $scope.backBeatActions = value.filter(action => action.Status === "Paused" || action.Status === "Error");
                    promise.resolve($scope.backBeatActions);
                },
                function (value) {
                    promise.reject(value);
                }
            );
        });
    }
    
    function loadHooks() {
        $rootScope.loadData('hooks', function (promise) {
            return Webhook.query({ failedFilter: true, take: 10, after: minDate },
                function (value) {
                    $scope.hooks = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function loadMigrations() {
        $rootScope.loadData('migrations', function (promise) {
            return Migration.queryImportant({},
                function (value) {
                    $scope.migrations = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function loadVatIdResult() {
        $rootScope.loadData('vatIdResult', function (promise) {
            return VatIdValidationResult.query({},
                function (value) {
                    $scope.vatIdResult = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function loadWorkerProcesses() {
        $rootScope.loadData('workerProcesses', function (promise) {
            return WorkerProcess.get({},
                function (value) {
                    $scope.workerProcesses = value;
                    promise.resolve(value);
                }, function (value) {
                    promise.reject(value);
                });
        });
    }

    function load() {
        loadLogs();
        loadJobs();
        loadActions();
        loadBackBeatActions()
        loadHooks();
        loadMigrations();
        loadVatIdResult();
        loadWorkerProcesses();

        $rootScope.$broadcast("refresh");
    }

    load();
    $scope.toggleAutoRefresh();

    //Cancel interval on scope destroy
    $scope.$on('$destroy', function () {
        $interval.cancel(interval);
    });
};
DashboardOperationsController.$inject = ['$scope', '$rootScope', '$location', '$routeParams', '$http', '$interval', 'Logs', 'Job', 'PrometheusAction','BackbeatAction', 'Webhook', 'Migration', 'VatIdValidationResult', 'WorkerProcess'];
